/**
 * Returns the file name without extension for display (e.g. "Liquid Seed" instead of "Liquid Seed.pdf").
 */
export function fileNameWithoutExtension(fileName: string): string {
  const base = fileName.replace(/\.[^.]+$/, "");
  return base === "" ? fileName : base;
}

export function formatFileSize(bytes: number, si = true, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
}
